import { useTheme } from "@emotion/react";
import { ChevronRight } from "@mui/icons-material";
import { alpha, Box, ButtonBase, CircularProgress, Typography } from "@mui/material";

export default function ActionRow({
  icon,
  label,
  description,
  onClick,
  disabled = false,
  loading = false,
  color = "default",
  justButton = false,
  testId
}) {
  const theme = useTheme();
  const isError = color === "error";

  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        width: "100%",
        px: 3,
        py: 2,
        textAlign: "left",
        color: isError ? "error.main" : "text.primary",
        transition: "background 0.15s ease",
        "&:hover": {
          bgcolor: isError
            ? alpha(theme.palette.error.main, 0.06)
            : "action.hover",
        },
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1.5,
          bgcolor: isError
            ? alpha(theme.palette.error.main, 0.1)
            : "action.selected",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: isError ? "error.main" : "action.active",
        }}
      >
        {loading ? <CircularProgress size={18} color="inherit" /> : icon}
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight={500}>
          {label}
        </Typography>
        {description && (
          <Typography
            variant="caption"
            color={isError ? "error.light" : "text.secondary"}
          >
            {description}
          </Typography>
        )}
      </Box>

      {!isError && !justButton && (
        <ChevronRight
          sx={{ fontSize: 18, color: "text.disabled", flexShrink: 0 }}
        />
      )}
    </ButtonBase>
  );
}